// Global
import { load } from '@shopify/theme-sections';

// Modules
import './layout/theme';
import './templates/templates.js';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  console.log('📦 Bundler: Loaded');
});
